import { API_BASE_URL } from '../config';
import { QuoteAnalyticsSummary, QuoteTimeSeriesPoint } from '../types';

export type QuoteAnalyticsDomain = 'chapas' | 'medalhas';

/**
 * Fetch quote analytics summary for a domain (chapas or medalhas)
 */
export async function fetchQuoteSummary(
  domain: QuoteAnalyticsDomain,
  startDate: string,
  endDate: string,
  accessToken: string
): Promise<QuoteAnalyticsSummary> {
  const params = new URLSearchParams();
  params.append('startDate', startDate);
  params.append('endDate', endDate);

  const endpoint = `${API_BASE_URL}/backoffice/analytics/quotes/${domain}/summary?${params.toString()}`;

  const response = await fetch(endpoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar resumo de orçamentos');
  }

  const payload = await response.json();
  return payload.data;
}

/**
 * Fetch daily time series for quote analytics
 */
export async function fetchQuoteDaily(
  domain: QuoteAnalyticsDomain,
  startDate: string,
  endDate: string,
  accessToken: string
): Promise<QuoteTimeSeriesPoint[]> {
  const params = new URLSearchParams();
  params.append('startDate', startDate);
  params.append('endDate', endDate);

  const endpoint = `${API_BASE_URL}/backoffice/analytics/quotes/${domain}/daily?${params.toString()}`;

  const response = await fetch(endpoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar dados diários');
  }

  const payload = await response.json();
  return payload.data;
}

/**
 * Fetch weekly time series for quote analytics
 */
export async function fetchQuoteWeekly(
  domain: QuoteAnalyticsDomain,
  startDate: string,
  endDate: string,
  accessToken: string
): Promise<QuoteTimeSeriesPoint[]> {
  const params = new URLSearchParams();
  params.append('startDate', startDate);
  params.append('endDate', endDate);

  const endpoint = `${API_BASE_URL}/backoffice/analytics/quotes/${domain}/weekly?${params.toString()}`;

  const response = await fetch(endpoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar dados semanais');
  }

  const payload = await response.json();
  return payload.data;
}

/**
 * Fetch monthly time series for quote analytics
 */
export async function fetchQuoteMonthly(
  domain: QuoteAnalyticsDomain,
  startDate: string,
  endDate: string,
  accessToken: string
): Promise<QuoteTimeSeriesPoint[]> {
  const params = new URLSearchParams();
  params.append('startDate', startDate);
  params.append('endDate', endDate);

  const endpoint = `${API_BASE_URL}/backoffice/analytics/quotes/${domain}/monthly?${params.toString()}`;

  const response = await fetch(endpoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar dados mensais');
  }

  const payload = await response.json();
  return payload.data;
}
